import NextImage from "next/image"
import { cloudinaryLoader } from "packages/ui-shared/components/Image/loaders/cloudinary-loader"
import React from "react"
import { getStaticFile } from "utils/getStaticFile"
import { imageContainerVariants } from "./Image.css"
interface CustomImageProps {
  src: string
  alt: string
  height?: number
  width?: number
  useCloudinary?: boolean
  variant?: "default" | "square"
}

export const BP_PRODUCT_CARD_IMAGE_QUALITY = 85

export const Image: React.FC<CustomImageProps> = ({
  src,
  alt,
  height,
  width,
  variant = "default",
  useCloudinary = false,
}) => {
  const propOverrides = {
    height,
    width,
    style: {},
    sizes: "",
    loader: useCloudinary ? cloudinaryLoader : undefined,
  }

  /**
   * NextImage requires height and width props to be defined
   * flex={true} does not work well as it directly sets position:absolute
   * and the image is not displayed as expected
   * So, we need to set height and width to 100% and auto respectively
   * 40 is an arbitrary value to avoid the warning
   */
  if (typeof height === "undefined" || typeof width === "undefined") {
    propOverrides.height = 40
    propOverrides.width = 40
    propOverrides.style = {
      width: "100%",
      height: "auto",
    }

    if (variant === "square") {
      propOverrides.style = {
        height: "100%",
        width: "100%",
        objectFit: "cover",
      }
    }

    propOverrides.sizes =
      "(max-width: 374px) 100vw, (max-width: 768px) 50vw, (max-width: 1440px) 33vw, 20vw"
  }

  return (
    <div className={imageContainerVariants[variant]}>
      <NextImage
        src={src}
        placeholder="blur"
        alt={alt}
        blurDataURL={getStaticFile("/images/placeholder.svg")}
        {...propOverrides}
        quality={BP_PRODUCT_CARD_IMAGE_QUALITY}
      />
    </div>
  )
}
